import $ from 'jquery';

class MyClass {
    
    name: string;
    age: number;


    constructor(name: string, age: number) {
      
      this.name = name;
      this.age = age;
      
      

    }

    Say() {
      console.log("say");
      $("#fuga").text("fugafugafuga");
    }

  }

  export {MyClass};
